import { ParsedUrlQuery } from 'querystring';

export const shouldUseMock = (query: ParsedUrlQuery = {}): boolean =>
  (query.mock === 'true' || process.env.NEXT_PUBLIC_E2E === '1') &&
  process.env.NODE_ENV !== 'production';

export const shouldUseMockOnSSR = (query: ParsedUrlQuery = {}): boolean =>
  typeof window === 'undefined' && shouldUseMock(query);
